import React from 'react';
import MemberRegistrationForm from '../../components/auth/MemberRegistrationForm';

const RegistrationPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-2xl w-full space-y-6 bg-white p-8 rounded-xl shadow-lg border border-gray-200">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-800">Create an Account</h2>
          <p className="mt-2 text-sm text-gray-600">
            Fill in your details to register as a new member.
          </p>
        </div>
        <MemberRegistrationForm />
      </div>
    </div>
  );
};

export default RegistrationPage;

